import { toast } from '@/hooks'
import { getProjectsMutations } from '@/modules/projects/hooks'
import { captureException } from '@/services/monitoring'
import { getProjectPath, getUrl, redirectTo } from '@/utils'

export const duplicateProject = async (slug: string) => {
  try {
    const copy = await getProjectsMutations().duplicateProject(slug)
    redirectTo(getUrl(getProjectPath({ slug: copy.slug })))
  } catch (error) {
    toast({
      title: "We couldn't duplicate this project",
      description: (error as Error).message,
      theme: 'destructive',
    })
    captureException(error as Error)
  }
}
